import { MaintenanceForwardingsCheckinEntryStepOptions } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwardingsShowDirectiveDetails.type";

export const checkinEntryOptions: {
  [K in MaintenanceForwardingsCheckinEntryStepOptions]: {
    title: string;
    description: string | undefined;
  }
} = {
  [MaintenanceForwardingsCheckinEntryStepOptions.AutoEntry]: {
    title: 'Auto-locomoção',
    description: 'Informe um usuário na sua empresa para transporte do equipamento, se aceito, o usuário será notificado.',
  },
}
